export default __webpack_public_path__ + "static/media/outreach.c7a73fb8.svg";